export const DISCOUNTED_MULTIPLIER = 0.8;
